module.exports = __webpack_public_path__ + "img/ead.e1f13cef.svg";